
import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog-post/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  // {
  //   path: '/blog',
  //   element: <BlogPage />,
  // },
  // {
  //   path: '/blog/:slug',
  //   element: <BlogPostPage />,
  // },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
